(() => {
  const MQ = window.matchMedia('(min-width: 750px)');
  const CHEVRON_LEFT =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M12.5 4L7 10l5.5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CHEVRON_RIGHT =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4L13 10l-5.5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  let index = 0;
  let slides = [];
  let root = null;
  let locked = false;

  function isSlideSection(el) {
    if (!el || !el.classList || !el.classList.contains('shopify-section')) return false;
    if (el.hidden || el.getAttribute('hidden') != null) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return Boolean(el.querySelector('.section--height-full-screen, .fse-section'));
  }

  function unwrap() {
    const existing = document.querySelector('.dss');
    if (!existing) return;
    const viewport = existing.querySelector('.dss__viewport');
    const parent = existing.parentNode;
    if (viewport && parent) {
      while (viewport.firstChild) {
        const slide = viewport.firstChild;
        slide.classList.remove('is-dss-active');
        slide.removeAttribute('hidden');
        slide.removeAttribute('aria-hidden');
        parent.insertBefore(slide, existing);
      }
    }
    existing.remove();
    root = null;
    slides = [];
  }

  function pauseMedia(slide) {
    slide.querySelectorAll('deferred-media').forEach((media) => {
      if (typeof media.pauseMedia === 'function') media.pauseMedia();
    });
    slide.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
  }

  function activateMedia(slide) {
    slide.querySelectorAll('img').forEach((img) => {
      img.loading = 'eager';
      if (img.dataset.src && img.getAttribute('src') !== img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
    slide.querySelectorAll('deferred-media').forEach((media) => {
      if (typeof media.loadContent === 'function') media.loadContent(false);
      if (typeof media.playMedia === 'function') media.playMedia();
    });
    slide.querySelectorAll('video').forEach((video) => {
      if (video.readyState === 0) video.load();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    });
  }

  function show(nextIndex) {
    if (!slides.length) return;
    index = Math.max(0, Math.min(nextIndex, slides.length - 1));
    slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-dss-active', active);
      slide.toggleAttribute('hidden', !active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) {
        activateMedia(slide);
      } else {
        pauseMedia(slide);
      }
    });
    if (!root) return;
    root.querySelectorAll('.dss__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
    const prev = root.querySelector('.dss__btn--prev');
    const next = root.querySelector('.dss__btn--next');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
  }

  function go(delta) {
    if (locked) return;
    const nextIndex = index + delta;
    if (nextIndex < 0 || nextIndex >= slides.length) return;
    locked = true;
    show(nextIndex);
    window.setTimeout(() => {
      locked = false;
    }, 450);
  }

  function setup() {
    unwrap();
    if (!MQ.matches) return;

    const main = document.getElementById('MainContent');
    if (!main) return;

    const found = [...main.children].filter(isSlideSection);
    if (found.length < 2) return;

    root = document.createElement('div');
    root.className = 'dss';
    root.setAttribute('data-dss', '');

    const viewport = document.createElement('div');
    viewport.className = 'dss__viewport';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'dss__btn dss__btn--prev';
    prevBtn.setAttribute('aria-label', 'Vorherige Sektion');
    prevBtn.innerHTML = CHEVRON_LEFT;

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'dss__btn dss__btn--next';
    nextBtn.setAttribute('aria-label', 'Nächste Sektion');
    nextBtn.innerHTML = CHEVRON_RIGHT;

    const dots = document.createElement('div');
    dots.className = 'dss__dots';
    dots.setAttribute('role', 'tablist');

    found.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dss__dot';
      dot.setAttribute('aria-label', `Sektion ${i + 1}`);
      dot.addEventListener('click', () => show(i));
      dots.appendChild(dot);
    });

    prevBtn.addEventListener('click', () => go(-1));
    nextBtn.addEventListener('click', () => go(1));

    root.appendChild(prevBtn);
    root.appendChild(viewport);
    root.appendChild(nextBtn);
    root.appendChild(dots);

    main.insertBefore(root, found[0]);
    found.forEach((slide) => viewport.appendChild(slide));
    slides = found;

    viewport.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaY) < 12) return;
        if (event.deltaY > 0 && index < slides.length - 1) {
          event.preventDefault();
          go(1);
        } else if (event.deltaY < 0 && index > 0) {
          event.preventDefault();
          go(-1);
        }
      },
      { passive: false }
    );

    const keepIndex = Math.max(0, Math.min(index, slides.length - 1));
    show(keepIndex);
  }

  function onKey(event) {
    if (!root || !MQ.matches) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      go(1);
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      go(-1);
    }
  }

  MQ.addEventListener('change', setup);
  document.addEventListener('keyup', onKey);
  document.addEventListener('shopify:section:select', (event) => {
    if (!slides.length) return;
    const i = slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
    if (i >= 0) show(i);
  });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:reorder', setup);
  document.addEventListener('shopify:section:unload', () => {
    window.setTimeout(setup, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
